export const frQuizzes = {
    'navbar.quizzes': 'Quiz',
    'quizzes.name': 'Quiz',

    //* QUIZZ LIST
    'quizzes.list.pageTitle': 'Quiz',
    'quizzes.title': 'Quiz',
    'quizzes.list.actions.addQuizz': 'Créer un quiz',
    'quizzes.list.table.emptyLabel': "Il n'y a pas de quiz pour le moment",

    //* QUIZZ INFORMATIONS
    'quizzes.info.input.title': 'Titre de quiz *',
    'quizzes.info.input.code': 'Référence du quiz',
    'quizzes.info.description': 'Saisissez ici la description du quiz',
    'quizzes.info.owner.select.title': 'Sélectionnez le propriètre du quiz',

    //* QUIZZ QUESTIONS
    'quizzes.questions.addQuestion': 'Ajouter une question',
    'quizzes.questions.questionTitle': 'Question {index}',
    'quizzes.questions.questionSubtitle': '{answerCount} Réponses',
    'quizzes.questions.description': 'Question',
    'quizzes.questions.descriptionHintText': 'Saisissez ici une question',
    'quizzes.questions.choiceCount': 'Nombre de choix',
    'quizzes.questions.choice_count_label': '{choiceCount} choix',
    'quizzes.questions.answerTitle': 'Réponse {index}',
    'quizzes.questions.answerHintText': 'Saisir ici la réponse',
    'quizzes.questions.answerGoodChoice': 'Bon choix',

    //* QUIZZ >> CREATE AND DETAILS
    'quizzes.create.pageTitle': 'Création quiz',
    'quizzes.details.pageTitle': 'Détails quiz',
    'quizzes.details.actions.previous': 'Quiz',
    'quizzes.details.remove.dialog.title': 'Suppression du quizz',
    'quizzes.details.remove.dialog.content': 'Êtes-vous sûr de vouloir supprimer ce quiz ?',

    //* QUIZZ NOTIFICATIONS // MANUAL
    'quizzes.details.tabs.notifs.manualInfo':
        'Relancer les utilisateurs qui n’ont pas consulté la publication',

    //* QUIZZ DETAILS //TABS //RESULTS

    'quizzes.details.results.filter.NotReplied': 'Pas répondu',
    'quizzes.details.results.filter.Replied': 'Répondu',
    'quizzes.details.results.filter.InProgress': 'En cours',

    'quizzes.details.results.tableHeader.shops': 'Centres',
    'quizzes.details.results.tableHeader.user': 'Utilisateur',
    'quizzes.details.results.tableHeader.state': 'État de quiz',
    'quizzes.details.results.tableHeader.last_score': 'Dernier Score',

    'quizzes.details.tabs.results.state.not_replied': 'Pas répondu',
    'quizzes.details.tabs.results.state.replied': 'Répondu',
    'quizzes.details.tabs.results.state.in_progress': 'En cours',
    'quizzes.details.tabs.results.score': '{score} / {count}',
    'quizzes.details.tabs.results.seeResult': 'Visualiser la réponse',

    'quizzes.details.results.emptyLabel': 'Aucun résultat pour le moment.',

    'quizzes.details.result.header.score': 'Score : {score} / {count}',

    'quizzes.details.result.question.title': 'Question {index}',
    'quizzes.details.result.question.answer': 'Réponse {index}',
    'quizzes.details.result.answer.good': 'Bonne réponse',
    'quizzes.details.result.answer.bad': 'Mauvaise réponse',

    //* QUIZZ PERMISSIONS
    'backofficeUsers.create.tabs.permissions.sectionTabs.quizzes': 'Quiz',
    'backofficeUsers.permissions.quizzes.contentcreate': 'Création de quiz',

    //* QUIZZ ERRORS
    'toast.apiErrors.QUIZ_MUST_HAVE_ONE_QUESTION': 'Un quiz doit avoir au moins un question',
    'toast.apiErrors.EVERY_QUESTION_MUST_HAVE_A_GOOD_CHOICE':
        'Chaque question doit avoir un bon choix',
};
